import {
  collection,
  onSnapshot,
  addDoc,
  serverTimestamp,
  getDocs,
  doc,
  getDoc
} from 'firebase/firestore';
import { db } from '../config/firebase';

// Subscrever aos carros disponíveis para venda (não vendidos)
export const subscribeToAvailableCars = (callback) => {
  try {
    const carsRef = collection(db, 'cars');

    return onSnapshot(carsRef, (snapshot) => {
      // Filtrar carros não vendidos e ordenar por data
      const cars = snapshot.docs
        .map(doc => ({
          _id: doc.id,
          ...doc.data()
        }))
        .filter(car => car.vendido === false)
        .sort((a, b) => {
          const dateA = a.createdAt?.seconds || 0;
          const dateB = b.createdAt?.seconds || 0;
          return dateB - dateA;
        });
      callback(cars);
    }, (error) => {
      console.error('Erro ao subscrever aos carros:', error);
      callback([]);
    });
  } catch (error) {
    console.error('Erro ao criar subscrição:', error);
    callback([]);
    return () => {};
  }
};

// Buscar todos os carros (incluindo vendidos)
export const getAvailableCars = async () => {
  try {
    const carsRef = collection(db, 'cars');
    const snapshot = await getDocs(carsRef);

    // Ordenar por data (não vendidos primeiro, depois vendidos)
    const cars = snapshot.docs
      .map(doc => ({
        _id: doc.id,
        ...doc.data()
      }))
      .sort((a, b) => {
        // Ordem: disponível → reservado → vendido
        const statusOrder = (car) => car.vendido ? 2 : car.reservado ? 1 : 0;
        if (statusOrder(a) !== statusOrder(b)) return statusOrder(a) - statusOrder(b);
        // Depois ordenar por data
        const dateA = a.createdAt?.seconds || 0;
        const dateB = b.createdAt?.seconds || 0;
        return dateB - dateA;
      });

    return cars;
  } catch (error) {
    console.error('Erro ao buscar carros:', error);
    return [];
  }
};

// Buscar um carro específico por ID (incluindo vendidos)
export const getCarById = async (carId) => {
  try {
    const carDoc = await getDoc(doc(db, 'cars', carId));

    if (!carDoc.exists()) {
      return null;
    }

    return {
      _id: carDoc.id,
      ...carDoc.data()
    };
  } catch (error) {
    console.error('Erro ao buscar carro:', error);
    return null;
  }
};

// Criar um lead quando alguém demonstra interesse num carro
export const createLead = async (leadData) => {
  try {
    const leadsRef = collection(db, 'leads');

    const lead = {
      nome: leadData.nome,
      email: leadData.email,
      telefone: leadData.telefone,
      mensagem: leadData.mensagem || '',
      carroId: leadData.carroId || null,
      carroMarca: leadData.carroMarca || '',
      carroModelo: leadData.carroModelo || '',
      status: 'ativo',
      origem: 'website', // Identificar que veio do website público
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    const docRef = await addDoc(leadsRef, lead);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Erro ao criar lead:', error);
    return { success: false, error: error.message };
  }
};

// Criar lead de contacto geral (sem carro específico)
export const createGeneralContact = async (contactData) => {
  try {
    const leadsRef = collection(db, 'leads');

    const lead = {
      nome: contactData.nome,
      email: contactData.email,
      telefone: contactData.telefone,
      mensagem: contactData.mensagem || '',
      carroId: null,
      carroMarca: '',
      carroModelo: '',
      status: 'ativo',
      origem: 'website-contacto', // Contacto geral
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    const docRef = await addDoc(leadsRef, lead);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Erro ao criar contacto:', error);
    return { success: false, error: error.message };
  }
};
